import React from "react";
import useFormHandler from "../../../Validations/useFormHandler";
import Modal from "../../../Modal/Modal";
import FormFieldSet from "../../../FormFields/FormFieldSet";
import Button from "../../../Buttons/Button";


const ChangeInvoiceNote = ({ onClose, isOpen }) => {
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      invoiceNote: "",
    },
    {
      invoiceNote: { type: "text", required: true },
    }
  );

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      console.log("form data:", formData);
      onClose();
    } else {
      console.log("error:", errors);
    }
  };
  return (
    <Modal
      title={"CHANGE INVOICE(S) NOTE"}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-5xl"
    >
      <div>
        <div className="grid grid-cols-1 mt-4 gap-x-6 gap-y-4 max-w-3xl">
          <FormFieldSet
            type="textArea"
            rows={5}
            title={"Invoice Note"}
            placeholder="Enter Invoice Note"
            value={formData.invoiceNote}
            onChange={(value) => handleChange("invoiceNote", value)}
            error={errors.invoiceNote}
          />
        </div>
        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Submit" onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeInvoiceNote;
